module.exports = __webpack_public_path__ + "img/noa_burnette_9.b26681eb.jpg";